import Controller from '../abstracts/Controller';
import 'scss-templates/t-data-enrichment.scss';
import 'scss-templates/t-register.scss';
import $ from 'jquery';

export default class DataEnrichmentController extends Controller {
  static get COMPONENTS() {
    return [
      'RegistrationComponent',
      'DatePickerComponent'
    ];
  }

  init() {
    super.init();
    const createAccountCheckbox = document.querySelector('[data-open-register]');

    if (createAccountCheckbox) {
      createAccountCheckbox.addEventListener('change', function(e) {
        const checked = e.currentTarget.checked;
        const pwdBox = document.querySelector('#show-password-box');
        const param11 = document.querySelector('#param11');
        if (pwdBox && param11) {
          checked ? pwdBox.classList.remove('--hidden') : pwdBox.classList.add('--hidden');
          param11.required = !pwdBox.classList.contains('--hidden');
        }
      });
    }
  }

}
